// Utils
import { http } from '../../utils/services/http';

export const fetchCurrentUserGoogleContacts = () =>
    http({
        url: 'users/me/google/contacts',
        timeout: 11000,
    }).then((res) => res.data);
